// src/components/ModuleEditor.jsx
import React from "react";
import { moduleRegistry } from "../utils/moduleRegistry";

function ModuleEditor(props) {
  const { module } = props;
  const ModuleComponent = moduleRegistry[module.type];

  if (!ModuleComponent) {
    return <div>Unsupported module type: {module.type}</div>;
  }

  return <ModuleComponent {...props} />;
}

export default ModuleEditor;
